angular.module('callX').controller('ApplicationFormCtrl', ['$scope','$modalInstance', '$state', 'UserService', '$rootScope', 'object', 'toaster', '$timeout', '$stateParams',function($scope,$modalInstance, $state, UserService, $rootScope, object, toaster, $timeout,$stateParams) {
    
    $scope.status = object;
    // console.log($scope.status,"get status in the form")
    $scope.companies = [];
    $scope.products = [];
    $scope.filteredAgentNames = [];
    angular.forEach($rootScope.agentNames, function(agent) {
        if (agent.id != $stateParams.userId) {
            $scope.filteredAgentNames.push(agent);
        }
    });
    $scope.insuredTypes = ['Final Expense', 'Term', 'Universal Life'];
    $scope.statusOptions = ['Approved', 'Declined', 'Underwriting'];
    $scope.isCompanyDropdownLoading = true;
    $scope.isSubmitting = false;
    $scope.isProductsLoading = false;

    $scope.user = {
        monthly_payment: 0,
        annual_payment: 0,
    }

    $scope.updateAnnualPayment = function() {
        $scope.user.annual_payment = $scope.user.monthly_payment * 12;
        $scope.user.annual_payment = $scope.user.annual_payment.toFixed(2)
    };

    $scope.updateMonthlyPayment = function() {
        $scope.user.monthly_payment = $scope.user.annual_payment / 12;
        $scope.user.monthly_payment = $scope.user.monthly_payment.toFixed(2)
    };

    $timeout(function() {
        $scope.user.split_agent = 'no';
    }, 0);

    $scope.setAgentFirsAandLastName = function() {
        $scope.firstName = window.localStorage.getItem("first_name")
        $scope.lastName = window.localStorage.getItem("last_name")
        // $scope.agent_name = $scope.firstName + ' ' + $scope.lastName;
        $scope.user_id = window.localStorage.getItem("user_id")
        $scope.email = window.localStorage.getItem("email")
    }
    $scope.setAgentFirsAandLastName();

    $scope.sortByName = function(data) {
        if (Array.isArray(data)) {
            return data.sort(function(a, b) {
                return a.name.localeCompare(b.name);
            });
        } else {
            console.error('Expected array for sorting, received:', data);
            return [];
        }
    };

    $scope.getCarrierDetails = function(){
        $scope.isCompanyDropdownLoading = true;

    	var callbacks = {
            success: function (data) {
                if (Array.isArray(data)) {
                    $scope.companies = $scope.sortByName(data);
                } else {
                    $scope.companies = [];
                    console.error('Expected array for companies, received:', data);
                }
                $scope.isCompanyDropdownLoading = false;
             },
            failure: function (data) {
                $scope.isCompanyDropdownLoading = false;
                toaster.pop('error', 'Error', 'Failed to load companies', 2000);
            }

        };
        UserService.getCarrierDetails(callbacks);
    };

    $scope.getProductsBasedOnCarrier = function(carrierId){
        $scope.isProductsLoading = true;
    	var callbacks = {
            success: function (data) {
                $scope.products = data;
                $scope.isProductsLoading = false;
             },
            failure: function (data) {
                $scope.isProductsLoading = false;
                toaster.pop('error', 'Error', 'Failed to load products', 2000);
            }

        };
        UserService.getProductsBasedOnCarrier(carrierId, callbacks);
    };
    $scope.getCarrierDetails()
    $scope.reloadData = function() {
        $scope.user.product_obj = null;
        $scope.getCarrierDetails();
        if ($scope.user.company) {
            $scope.getProductsBasedOnCarrier($scope.user.company.id);
        }
    };

    $scope.$watch('user.company', function(newValue) {
        if (newValue) {
            var selectedCompany = $scope.companies.find(function(company) {
                return company.id === newValue.id;
            });
             $scope.user.company = selectedCompany;
             $scope.products = []
             $scope.user.product_obj = null
             $scope.getProductsBasedOnCarrier($scope.user.company.id)
        }
    });

    $scope.productChange = function(val) {
        if(val) {
            $scope.user.type = JSON.parse(val).product_type
        }
    };

    //  $scope.getCarrierArray = function(){
    // 	var callbacks = {
    //         success: function (data) {
    //             // console.log(data, "get carriers data")
    //             $rootScope.companies = data;
    //          },
    //         failure: function (data) {
    //             toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
    //         }

    //     };
    //     UserService.getCarrierDetails(callbacks);
    // };
    // $scope.getCarrierArray()

    // $scope.getAgentsArray = function(){
    // 	var callbacks = {
    //         success: function (data) {
    //             $rootScope.agentNames = data;
    //          },
    //         failure: function (data) {
    //             toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
    //         }
    //     };
    //     UserService.getAgentDetails(callbacks);
    // };
    // $scope.getAgentsArray();

    // $scope.checkKey = function(event) {
    //     var keyCode = event.which || event.keyCode;
    //     if ((keyCode < 48 || keyCode > 57) && 
    //         ![8, 37, 38, 39, 40, 46, 9].includes(keyCode)) {
    //         event.preventDefault();
    //     }
    // };

    $scope.checkKey = function(event) {
 
        var keyCode = event.which || event.keyCode;
        var inputValue = event.target.value || '';
        var num = '';
        var decNum = '';
        inputValue = inputValue.replace(/[^0-9.]/g, '');
        if (inputValue.includes('.')) {
            num = inputValue.split('.')[0];
            decNum = inputValue.split('.')[1];
            if (decNum.length > 1) {
                event.preventDefault(); 
                decNum = decNum.substring(0, 2);
            }
        } else {
            num = inputValue; 
        }
        inputValue = num + '.' + decNum;

        if ([8, 37, 38, 39, 40, 46, 9].includes(keyCode)) {
            return;
        }
        if (keyCode === 190) {
            if (inputValue.indexOf('.') !== -1) {
                event.preventDefault(); 
            }
            return;
        }
        if (keyCode < 48 || keyCode > 57) {
            event.preventDefault(); 
        }
        if (inputValue.includes('.')) {
            var decimalPart = inputValue.split('.')[1];
            if (decimalPart.length >= 2) {
                event.preventDefault(); 
            }
        }
    };
    
     //calendar starts  
    //  $scope.dpOpened1 = false;
     $scope.dpOpened2 = false;

     $scope.user = {
        submitted_date: null,
        effective_date: null
    };

     $scope.today = function() {
        var todayDate = new Date();
        $scope.minDate = todayDate;
        $scope.user.submitted_date = todayDate.getFullYear() + '-' +
            ('0' + (todayDate.getMonth() + 1)).slice(-2) + '-' +
            ('0' + todayDate.getDate()).slice(-2);        
    };

    $scope.today();
 
     $scope.open = function($event) {
         $event.preventDefault();
         $event.stopPropagation();
        //  $scope.dpOpened1 = !$scope.dpOpened1;
         $scope.dpOpened2 = !$scope.dpOpened2;
     };
  
     $scope.format = 'MM/dd/yyyy';
    // $scope.format = 'MMMM dd, yyyy';
  
     $scope.$watch('$scope.user.submitted_date', function (newDate) {
        if(newDate){
            $scope.today()
        }
     }); 
     $scope.$watch('$scope.user.effective_date', function (newDate) {
        if(newDate){
            $scope.user.effective_date = moment($scope.user.effective_date).format('dd/MM/yyyy');
        }
    });

    $scope.clear = function () {
        $scope.user.submitted_date = null;
        $scope.user.effective_date = null;
    };
    $scope.disabled = function(date, mode) {
        return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
    };
    $scope.toggleMin = function() {
        $scope.minDate = new Date(); 
    };
    $scope.toggleMin();
 
    //  $scope.openDatePickerSubmitted = function($event) {
    //      console.log("open submitted date")
    //      $event.preventDefault();
    //      $event.stopPropagation();
    //      $scope.openedFrom = true;
    //  }; 

     $scope.openDatePickerEffective = function($event) {
        // console.log("open effective date")
        $event.preventDefault();
        $event.stopPropagation();
        $scope.openedTo = true;
    };
 
     $scope.dateOptionsDatePicker = {
         formatYear: 'yy',
         startingDay: 0,
         class: 'datepicker',
         minDate: moment(),
         showWeeks:false
     };
     //calendar ends

    $scope.formatDateToYYYYMMDD = function(date) {
        if (!(date instanceof Date) || isNaN(date.getTime())) {
            throw new Error('Invalid date');
        }
        var year = date.getFullYear();
        var month = String(date.getMonth() + 1); 
        var day = String(date.getDate());
        month = month.length === 1 ? '0' + month : month;
        day = day.length === 1 ? '0' + day : day;
        return year + '-' + month + '-' + day + " " + '00:00:00';
    }

     $scope.submitApplicationForm = function(){
         if ($scope.isSubmitting) return; 
         $scope.isSubmitting = true;

        if(!$scope.user.company){
            toaster.pop('error', 'Company', 'Company field Required', 2000);
            $scope.isSubmitting = false;
            return;
        }else if(!$scope.user.product_obj){
            toaster.pop('error', 'Product', 'Product field Required', 2000);
            $scope.isSubmitting = false;
            return;
        }else if(!$scope.user.policy_number){
            toaster.pop('error', 'Policy', 'Policy field Required', 2000);
            $scope.isSubmitting = false;
            return;
        }
        else if ($scope.user.split_agent === undefined || $scope.user.split_agent === null) {
            toaster.pop('error', 'Split Agent', 'Split Agent field Required', 2000);
            $scope.isSubmitting = false;
            return;
        }else if ($scope.user.split_agent === 'yes' && !$scope.user.agent) {
            toaster.pop('error', 'Agent', 'Agent Name field Required when Split Agent is Yes', 2000);
            $scope.isSubmitting = false;
            return;
        } 
        else if(!$scope.user.type){
            toaster.pop('error', 'Insured Types', 'Insured Types field Required', 2000);
            $scope.isSubmitting = false;
            return;
        }else if(!$scope.user.annual_payment && !$scope.user.monthly_payment){
            toaster.pop('error', 'Payment', 'Payment field Required', 2000);
            $scope.isSubmitting = false;
            return;
        }else if (!$scope.user.submitted_date) {
            toaster.pop('error', 'Date', 'Submitted Date field is required', 2000);
            $scope.isSubmitting = false;
            return; 
        }else if (!$scope.user.effective_date) {
            toaster.pop('error', 'Date', 'Effective Date field is required', 2000);
            $scope.isSubmitting = false;
            return; 
        }else if(!$scope.user.status){
            toaster.pop('error', 'Status', 'Status field Required', 2000);
            $scope.isSubmitting = false;
            return;
        }else {

            if ($scope.user.split_agent === undefined) {
                $scope.user.split_agent = 'no';
            }

            if($scope.user.split_agent === 'yes'){
                $scope.user.split_agent = true;
                var selectedSplitId = $scope.user.agent.id;
                // console.log("Selected Agent ID:", selectedSplitId);
            }else {
                $scope.user.split_agent = false;
                var selectedSplitId = 0;
            }

                var selectedCompanyId = $scope.user.company.id;
                // console.log("Selected Company ID:", selectedCompanyId);

                console.log($scope.user.annual_payment, $scope.user.monthly_payment, "get with decimals")
                var annualPayment = parseInt($scope.user.annual_payment, 10);
                var monthlyPayment = parseInt($scope.user.monthly_payment, 10);
                console.log(annualPayment,monthlyPayment, "with decimals as .00")

                var formattedSubmittedDate = $scope.user.submitted_date ? $scope.user.submitted_date + ' 00:00:00' : '';
                var formattedEffectiveDate = $scope.user.effective_date ? $scope.formatDateToYYYYMMDD(new Date($scope.user.effective_date)) : '';
                if (!formattedSubmittedDate) {
                    toaster.pop('error', 'Submitted Date', 'Submitted Date is invalid', 2000);
                    $scope.isSubmitting = false;
                    return; 
                }
                if (!formattedEffectiveDate) {
                    toaster.pop('error', 'Effective Date', 'Effective Date is invalid', 2000);
                    $scope.isSubmitting = false;
                    return; 
                }

                $scope.productObject = JSON.parse($scope.user.product_obj);

                var formData = {
                    contact_id: object.contact_id,
                    carrier_id: selectedCompanyId,
                    product_id: $scope.productObject.id,
                    policy_number: $scope.user.policy_number,
                    agent_id: $scope.user_id,
                    insurance_type: $scope.user.type,
                    status: $scope.user.status,
                    split_with_agent: $scope.user.split_agent,
                    split_agent_id: selectedSplitId,
                    split_agent_name: $scope.user.agent,
                    annual_payment: parseFloat($scope.user.annual_payment),
                    monthly_payment: parseFloat($scope.user.monthly_payment),
                    submitted_date: formattedSubmittedDate,
                    effective_date: formattedEffectiveDate,
                };
                console.log(formData,formData.product_id, "get application data")
                // $modalInstance.close(formData);
                   var callbacks = {
                            success: function (response, statusCode) {
                              console.log(response,statusCode, "get success response from Application")
                              $scope.isSubmitting = false;
                                if(statusCode === 200){
                                    toaster.pop('success', 'Success', 'Created Application Successfully', 2000);
                                     $modalInstance.close('ok');
                                }
                            },
                            error: function (response) {
                              $scope.isSubmitting = false;
                              console.log('get error response from application', response)
                              toaster.pop('error', 'Error', 'An unknown error occurred', 2000);
                            }
                          };
                    UserService.createApplication(formData, callbacks);
            }   
    };

    // $scope.ok = function () {
    //     $modalInstance.close('ok');
    // };  

    $scope.closeModal = function() {
        $modalInstance.close('cancel');
      }; 


}])
